//  学习班管理 api
import request from '@/api/request'

// 获取修改页面数据
export function studyclassEditInitApi(id:string){
    let url = '/api/manager/studyclass/edit/init';
    let data = {
        "id":id
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 更新修改页面
export function studyclassEditSaveApi(data:any){
    let url = '/api/manager/studyclass/edit/save';
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 增加文章
export function studyclassAddApi(data:any){
    let url = '/api/manager/studyclass/save';
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 增加文章
export function options(data:any){
    let url = '/api/manager/studyclass/options';
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 报表学时信息详情
export function studyclassHoursDetailApi(data:any){
    let url = '/api/manager/studyClassReport/detail';
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 排课信息详情
export function classPlanDetailApi(data:any){
    let url = '/api/manager/studyClassReport/sheduleDetail';
    return request({
        url: url,
        method: 'post',
        data
    })
}
